import { AlertTriangle } from "lucide-react";
import { MODULE_BANNER_TITLE, MODULE_BANNER_BODY } from "../lib/disclaimer";

/**
 * Amber clinical-decision-support banner shown at the top of every clinical
 * module. Reuses the route-prefix list in `lib/disclaimer.js` via Layout.
 */
export default function DisclaimerBanner() {
  return (
    <div
      data-testid="clinical-disclaimer-banner"
      role="alert"
      className="flex items-start gap-3 p-3 sm:p-4 rounded-md border border-amber-500/40 bg-amber-500/10 mb-6"
    >
      <AlertTriangle
        size={18}
        className="text-amber-400 mt-0.5 shrink-0"
        aria-hidden="true"
      />
      <div className="min-w-0">
        <div className="text-xs sm:text-sm font-semibold text-amber-300 uppercase tracking-wide">
          {MODULE_BANNER_TITLE}
        </div>
        <p className="text-[11px] sm:text-xs text-amber-200/90 mt-1 leading-snug">
          {MODULE_BANNER_BODY}
        </p>
      </div>
    </div>
  );
}
